// extracted by mini-css-extract-plugin
export default {"languageSelectionDropdown":"LanguageSelection_languageSelectionDropdown__mbTh-"};